import React from 'react';
import clsx from 'clsx';
import { caretRight } from '../../../../../../../assets/hostedassets';
import profileStyles from './UserProfile.module.scss';
import type { Education, CollapsibleCardProps } from './ManagementUserProfile.types';

// Card shell for the five collapsible sections. The whole header is the toggle, not just the
// chevron — a 24px hit target is too small and people click the title.
const CollapsibleCard = ({ id, title, expanded, onToggle, children, variant }: CollapsibleCardProps) => (
    <div className={clsx(profileStyles.Card, variant === 'known' && profileStyles.CardKnown)}>
        <button
            type="button"
            className={profileStyles.CardHeader}
            aria-expanded={expanded}
            aria-controls={expanded ? id : undefined}
            onClick={onToggle}
        >
            <span className={profileStyles.CardTitle}>{title}</span>
            <img
                src={caretRight}
                alt=""
                aria-hidden="true"
                className={clsx(profileStyles.ChevronIcon, { [profileStyles.ChevronExpanded]: expanded })}
            />
        </button>
        {expanded && (
            // Modifier, not a replacement: the legacy/PDF markup shares .DataRows.
            <div id={id} className={clsx(profileStyles.DataRows, profileStyles.DataRowsFlat)}>
                {children}
            </div>
        )}
    </div>
);

export default CollapsibleCard;
